export const POSTAL_CODE_LENGTH = 5;
export const SMS_VERIFICATION_CODE_LENGTH = 4;



// WEBPACK FOOTER //
// ./src/app/constants/numbers.ts